import { ComponentMap } from '@cinch-nx/data-storyblok'
import { CarsCarousel, GridRows, OfferCard } from '../molecule-blocks'
import { atomStoryblokComponents } from './atom-storyblok-components-map'

const moleculeStoryblokComponents: ComponentMap = {
  CarsCarousel,
  GridRows,
  OfferCard,
}

export const sharedStoryblokComponents: ComponentMap = {
  ...atomStoryblokComponents,
  ...moleculeStoryblokComponents,
}
